'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$UpdateCP(username, pin, base64Cert) {
  this.a0m = null;
  this.a0l = null;
  this.a0k = null;
  this.a0m = username;
  this.a0l = pin;
  this.a0k = base64Cert;
}
export { $c_Lpresto_types$proto$UpdateCP as $c_Lpresto_types$proto$UpdateCP };
$p = $c_Lpresto_types$proto$UpdateCP.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$UpdateCP;
/** @constructor */
function $h_Lpresto_types$proto$UpdateCP() {
}
export { $h_Lpresto_types$proto$UpdateCP as $h_Lpresto_types$proto$UpdateCP };
$h_Lpresto_types$proto$UpdateCP.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$proto$UpdateCP)) {
    if ((this.a0m === x$0.a0m)) {
      var x = this.a0l;
      var x$2 = x$0.a0l;
      var $x_1 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.a0k;
      var x$4 = x$0.a0k;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "UpdateCP";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.a0m;
      break;
    }
    case 1: {
      return this.a0l;
      break;
    }
    case 2: {
      return this.a0k;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$proto$UpdateCP(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.md)));
}
export { $isArrayOf_Lpresto_types$proto$UpdateCP as $isArrayOf_Lpresto_types$proto$UpdateCP };
var $d_Lpresto_types$proto$UpdateCP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$UpdateCP, "presto.types$proto$UpdateCP", ({
  md: 1,
  bx: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$UpdateCP as $d_Lpresto_types$proto$UpdateCP };
//# sourceMappingURL=presto.types$proto$-Update-C-P.js.map
